<template>
<div class="animated fadeIn">
  <b-card no-body>
    <b-card-body fluid="xl">
          <b-form @submit.stop.prevent="onSubmit">
          <b-row>
          <b-col>

              <b-form-group label="Errors" v-if="showDismissibleAlert">
                  <b-alert variant="danger" :show="showDismissibleAlert"  @dismissed="showDismissibleAlert=false" dismissible fade>
                  <span v-for="items in submissionErros">
                    <ul v-for="item in items">
                      <li> {{item}} </li>
                    </ul>
                 </span>

                </b-alert>
             </b-form-group>
          </b-col>
          </b-row>
          <b-row>
          <b-col>
          <b-form-group label="Id Number" label-for="idNumber">
            <b-form-input id="idNumber" :state="validateState('idNumber')" name="idNumber"   aria-describedby="liveFeedbackIdNumber"  v-model.lazy.trim="$v.form.idNumber.$model" />
            <b-form-invalid-feedback id="liveFeedbackIdNumber">
               This is a required field.
             </b-form-invalid-feedback>
          </b-form-group>
          </b-col>
          <b-col>
          <b-form-group label="Name" label-for="visitorname">
            <b-form-input  id="visitorname" name="visitorname" :state="validateState('visitorname')"  aria-describedby="liveFeedbackVisitorname"  v-model="$v.form.visitorname.$model" />
            <b-form-invalid-feedback id="liveFeedbackVisitorname">
               This is a required field.
             </b-form-invalid-feedback>
          </b-form-group>
          </b-col>
          </b-row>
          <b-row>
          <b-col>
          <b-form-group label="Mobile Number" label-for="mobileNumber">
            <b-form-input id="mobileNumber" name="mobileNumber"  @blur="blurMethod"  @focus="mobileNumberFocused" :state="validateState('mobileNumber')"  maxlength="12" aria-describedby="liveFeedbackMobileNumber"  v-model="$v.form.mobileNumber.$model"  />

            <b-list-group v-if="showListGroup" id="mobileSearchList">
               <b-list-group-item ref="listIndexes" @keydown="keydownMethod(index)" @keyup="keyupMethod(index)"  @click="searchListClicked(item)" v-for="(item,index) in visitors" button  v-bind:key="item.id">{{item.name}} - {{item.mobile}}</b-list-group-item>
            </b-list-group>

            <b-form-invalid-feedback id="liveFeedbackMobileNumber">
               This is a required field.
             </b-form-invalid-feedback>
          </b-form-group>
          </b-col>
         </b-row>
         <b-row>
         <b-col>
          <b-form-group label="Country" label-for="country">
            <v-select ref="country" id="country" name="country" :class="{ danger: $v.form.country.$error }" @search:blur="$v.form.country.$touch()" :state="validateState('country')" :options="countriesList"  aria-describedby="liveFeedbackcountry" v-model="$v.form.country.$model" :reduce="country => country.id" label="name"></v-select>
            <span v-show="$v.form.country.$error" class="danger-span">
              This is required field
          </span>
           <b-form-invalid-feedback id="liveFeedbackcountry">
              This is a required field.
            </b-form-invalid-feedback>
          </b-form-group>
          </b-col>
          <b-col>
          <b-form-group label="Id Proof" label-for="idProof">
            <v-select ref="idProof" id="idProof" name="idProof"  :options="idProofsList"  v-model="form.idProof" :reduce="idProofs => idProofs.id" label="name"></v-select>
          </b-form-group>
          </b-col>
         </b-row>
          <b-row>
          <b-col>
          <b-form-group label="Mobile(s) Collected " label-for="mobilesCollected">
            <b-form-input id="mobilesCollected"  name="mobilesCollected" :state="validateState('mobilesCollected')" aria-describedby="liveFeedbackmobilesCollected" v-model.lazy="$v.form.mobilesCollected.$model"  />
            <b-form-invalid-feedback id="liveFeedbackmobilesCollected">
               Please enter numbers only...
             </b-form-invalid-feedback>
          </b-form-group>
          </b-col>
          <b-col>
          <b-form-group label="Tour Type" label-for="tourType">
            <v-select ref="tourType" id="tourType"  :options="tourTypesList"  v-model="form.tourType" :reduce="tourTypes => tourTypes.id" label="name"></v-select>


          </b-form-group>
          </b-col>
          </b-row>
          <b-row>
          <b-col>
          <b-form-group label="No of Gents" label-for="gents">
            <b-form-spinbutton id="gents"  v-model="$v.form.$model.gents" min=0 max=10000 @change="calculateTotalVisitors"  inline></b-form-spinbutton>
          </b-form-group>
          </b-col>
          <b-col>
          <b-form-group label="No of Ladies" label-for="ladies">
            <b-form-spinbutton id="ladies" v-model="$v.form.$model.ladies"  min=0 max=10000 @change="calculateTotalVisitors" inline></b-form-spinbutton>
          </b-form-group>
          </b-col>
          <b-col>
          <b-form-group label="No of Children" label-for="children">
            <b-form-spinbutton id="children"  v-model="$v.form.$model.children"  min=0 max=10000  @change="calculateTotalVisitors"  inline></b-form-spinbutton>
          </b-form-group>
          </b-col>
          <b-col>
          <b-form-group label="Total No of People" label-for="totalPeople">
            <b-form-spinbutton id="totalPeople" v-model="form.totalPeople" min=0 max=30000 inline  disabled></b-form-spinbutton>
          </b-form-group>
          </b-col>
          </b-row>
          <b-row>
          <b-col>
          <b-form-group  label-for="trayRequired">
          <b-form-checkbox v-model="form.trayRequired" id="trayRequired" name="trayRequired" switch>
            Tray Required
          </b-form-checkbox>
          </b-form-group>
          </b-col>
          </b-row>
          <b-row>
          <b-col>

          <b-button ref="submitButton" type="submit" variant="primary" :disabled="$v.form.$invalid">
            Submit
          </b-button>
          </b-col>
          <b-col>
          <b-button class="ml-1" type="reset" @click="onCancel">Close</b-button>
          </b-col>
          <b-col v-if="showPrintButton">
          <b-button class="ml-1"  variant="info" @click="callReceiptService">Re-Print</b-button>
          </b-col>
          </b-row>
          <br/>
          <b-row>
            <b-col>
              <b-form-group>
                <b-btn
                  variant="outline-info"
                  class="mb-2"
                  @click="showCollapse = !showCollapse"
                  ><i
                    :class="
                      showCollapse ? 'fa fa-minus fa-lg' : 'fa fa-plus fa-lg'
                    "
                  ></i>
                  Show Advanced Fields</b-btn
                >
              </b-form-group>
            </b-col>
          </b-row>
          <b-collapse id="collapseOwner" v-model="showCollapse" >
            <b-card-body class="borderCard">
          <b-row>
          <b-col>

                      <b-form-group label="Father/Husband " label-for="fatherHus">
                        <b-form-input id="fatherHus" type="text" v-model.lazy.trim="form.fatherHus" placeholder="Father Name OR Husband Name" />
                      </b-form-group>

                  </b-col>
                  <b-col>
                    <b-form-group label="Birth Year" label-for="birthYear">
                      <v-select ref="birthYear" id="birthYear" name="birthYear"  :options="birthYears"  v-model="$v.form.birthYear.$model" ></v-select>
                    </b-form-group>
                  </b-col>


                <b-col>
                <b-form-group label="District" label-for="district">
                  <b-form-input id="district"  name="district"  v-model.lazy.trim="form.district"  />
                </b-form-group>
                </b-col>
                </b-row>
                <b-row>
                <b-col>
                <b-form-group label="Location" label-for="location">
                  <b-form-input id="location" name="location"  v-model.lazy.trim="form.location" />
                </b-form-group>
                </b-col>


                <b-col>
                <b-form-group label="State" label-for="state">
                  <b-form-input id="state"  name="state"  v-model.lazy.trim="form.state"  />
                </b-form-group>
                </b-col>
                <b-col>
                <b-form-group label="PostCode" label-for="postcode">
                  <b-form-input id="postcode" name="postcode"  :state="validateState('postcode')" v-model.lazy.trim="$v.form.postcode.$model" aria-describedby="liveFeedbackPostcode"  />
                  <b-form-invalid-feedback id="liveFeedbackPostcode">
                     Please enter number only.
                   </b-form-invalid-feedback>
                </b-form-group>
                </b-col>
                </b-row>
                <b-row>
                <b-col>
                <b-form-group label="Email" label-for="email">
                  <b-form-input id="email"  name="email" :state="validateState('email')" v-model.lazy.trim="$v.form.email.$model"  aria-describedby="liveFeedbackEmail" />
                  <b-form-invalid-feedback id="liveFeedbackEmail">
                     Please enter valid email.
                   </b-form-invalid-feedback>
                </b-form-group>
                </b-col>
                <b-col>
                <b-form-group label="VehicleNo" label-for="vehicleNo">
                  <b-form-input id="vehicleNo" name="vehicleNo" v-model.lazy.trim="form.vehicleNo"  />
                </b-form-group>
                </b-col>


                  <b-col>
                  <b-form-group label="Gender" label-for="gender">
                    <v-select ref="gender" id="gender" name="gender"  :options="genderList"  v-model="form.gender" :reduce="genders => genders.id" label="name"></v-select>
                  </b-form-group>
                  </b-col>
                 </b-row>
            </b-card-body>
          </b-collapse>
          </b-form>

    </b-card-body>
  </b-card>
</div>
</template>
<script>
import Vue from 'vue'
import VueLodash from 'vue-lodash'
import map from 'lodash/map'
import {
  mapState,
  mapActions
} from 'vuex'

import { validationMixin } from "vuelidate";
import { required, minLength,numeric, minValue, maxLength, email,alpha,helpers } from "vuelidate/lib/validators";

const alpha_space = helpers.regex('alpha_space', /^[a-zA-Z\s]*$/)


const receiptShape = {
  receiptType: "samadh",
  visitdate: null,
  name: null,
  ismobprint: false,
  id: null,
  mobilecollected: 0,
  trayNo: null,
  totalVisited: null
}

const formShape = {
  idNumber: null,
  visitorname: null,
  mobileNumber: null,
  mobilesCollected: 0,
  tourType: {"id": "3", "name":"FAMILY"},
  gents: 0,
  ladies : 0,
  children: 0,
  totalPeople: 0,
  trayRequired: false,
  fatherHus: "",
  country: {"id": "IND", "name":"India"},
  idProof: {"id": "2", "name":"ADHAAR CARD"},
  birthYear: "",
  district: "",
  location: "",
  state: "",
  postcode: "",
  email: "",
  vehicleNo: "",
  gender: ""

}
export default {
  mixins: [validationMixin],
  name: "AadharCardInformation",
  props: {
    aadharCardInfo: Object
  },
  data() {
    return {
      form: Object.assign({}, formShape),
      receipt: Object.assign({}, receiptShape),
      submitted: false,
      showDismissibleAlert: false,
      submissionErros: "",
      selectedSearchOption : false,
      visitors: [],
      showPrintButton : false,
      showCollapse: false,

    }
  },

  validations: {
    form: {
      idNumber: {
        required
        },
        visitorname:{
          required,
          alpha_space
        },
        mobileNumber: {
          required,
          numeric,
          minLength : minLength(10),
          maxLength : maxLength(12)
        },
        country:{
          required
        },
        mobilesCollected: {
          numeric
        },
        birthYear: {
          numeric
        },
        postcode: {
          numeric
        },
        email: {
          email
        }

    }
  },
  watch: {

    'form.mobileNumber': function(value){
      let params = {"mobileNo": value};
      if(value != null && value.length >= 7 && this.selectedSearchOption == false){
        this.$store.dispatch('samadh/getVisitorsByMobile', params)
          .then((response) => {
                this.visitors = response.data.data;
          })
          .catch((error) => {
          });
      }

    }
  },
  computed: {
    showListGroup : function(){
      var strMob = '' + this.form.mobileNumber;
      return (this.visitors.length > 0 && this.selectedSearchOption === false && strMob.length >= 7)
    },
    isValid() {
      this.$v.$touch();
      return !this.$v.form.$anyError
    },
    isDirty() {
      return this.$v.form.$anyDirty
    },
    genderList(){
      return map(this.$store.state.samadh.genders, (gender) => {
      return {
        name: gender.name,
        id: gender.id
      }

      })
    },
    idProofsList(){
      return map(this.$store.state.samadh.idProofs, (idproof) => {
      return {
        name: idproof.name,
        id: idproof.id
      }

      })
    },
    tourTypesList(){
      return map(this.$store.state.samadh.tourTypes, (troutype) => {
      return {
        name: troutype.name,
        id: troutype.id
      }

      })
    },
    countriesList() {
      return map(this.$store.state.samadh.countries, (country) => {
      return {
        name: country.name,
        id: country.id
      }

      })
    },
    birthYears () {
     const year = new Date().getFullYear()
     return Array.from({length: year - 1900}, (value, index) => 1901 + index)
    },
  },
  methods: {
    blurMethod(){
      if(this.showListGroup == true && event.relatedTarget.parentNode != null && event.relatedTarget.parentNode.id !='mobileSearchList' ){
       this.selectedSearchOption = true;
      }
    },
    keydownMethod(index){
      if(index == (this.visitors.length - 1) && event.keyCode == 9 && event.shiftKey == false){
        event.preventDefault();
        this.$refs.listIndexes[index].focus();
        return false;

      }
      else if (index == 0 && event.keyCode == 9 && event.shiftKey == true ){
        this.visitors = [];
      }
    },
    keyupMethod(index){
      if(event.keyCode == 27){
        this.selectedSearchOption = true;
      }
    },
    mobileNumberFocused(){
        this.selectedSearchOption = false;
    },
    getValueFromKey(searchKey, sourceList){
      if(searchKey != null){
        for (var key in sourceList) {
          if (sourceList[key].id == searchKey) return sourceList[key];
        }
      }
      return null;
    },
    searchListClicked(item){
      this.selectedSearchOption = true;
      this.form.idNumber = item.uid;
      this.form.visitorname = item.name;
      this.form.mobileNumber = item.mobile;
      this.form.fatherHus = item.fatherhus;
      this.form.country = this.getValueFromKey(item.country, this.countriesList);
      this.form.birthYear = item.birthyear;
      this.form.district = item.distc;
      this.form.location = item.location;
      this.form.state = item.state;
      this.form.postcode = item.postcode;
      this.form.email = item.email;
      this.form.gender = this.getValueFromKey(item.gender, this.genderList);
      this.visitors = [];

    },
    onCancel() {
      this.$emit('cancel')
      this.onReset();
    },
    calculateTotalVisitors(){
        this.form.totalPeople =  this.$v.form.$model.gents + this.$v.form.$model.ladies + this.$v.form.$model.children;
    },
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
     callReceiptService(){
       this.$nextTick(() => {
        let params = JSON.stringify(this.receipt);
        console.log(params);
        this.$store.dispatch('samadh/printReceipt', params)
          .then((response) => {
            console.log(response.data.status);
            if(response.data.status == 'error'){
                if(response.data.message != null){
                  this.showErrorMsg({
                  message: "Print Failed: " + response.data.message
                });
                }
                else{
                  this.showErrorMsg({
                    message: "Print Failed. Please check Print service is running."
                  });
                }

                this.showPrintButton = true;

              }
              else{
                  this.showPrintButton = false;
                  this.$emit('success')
                  this.onReset();

              }
          })
          .catch((error) => {
            if(error.response != null && error.response.data.message != null){
              this.showErrorMsg({
                message: "Print Failed: " + error.response.data.message
              });
            }
            else{
              this.showErrorMsg({
                message: "Print Failed. Please check Print service is running."
              });
            }

            this.showPrintButton = true;

          })
    });

    },
    async printReceipt(data){

      this.receipt.receiptType = "samadh";
      this.receipt.visitdate = data.visitdate;
      this.receipt.name = this.form.visitorname;
      this.receipt.ismobprint = this.form.mobilesCollected > 0 ? true : false;
      this.receipt.id = data.uid;
      this.receipt.mobilecollected = this.form.mobilesCollected;
      this.receipt.trayNo =  data.trayNo;
      this.receipt.totalVisited = this.form.totalPeople;

      await this.callReceiptService();



    },
    onSubmit(evt){
      console.log(JSON.stringify(this.form, null, 4));
      if(this.isValid){
        this.submitted = true;
        this.$refs.submitButton.disabled = true;
        this.$nextTick(() => {
          let params = JSON.stringify(this.form);
          this.$store.dispatch('samadh/createVisit', params)
            .then((response) => {
              if(response.data.success == false){
                  this.showErrorMsg({
                    message: response.data.error
                  });
                  this.$refs.submitButton.disabled = false;
              }
              else{
                      this.showSuccessMsg({
                        message: 'Record Added successfully.'
                      });
                      this.printReceipt(response.data.data);
              }
            })
            .catch((error) => {
              if (error.response.status == 400) {
                this.showErrorMsg({
                  message: error.response.data.message
                })
              }
              else if (error.response.status == 422){
                  this.showErrorMsg({
                    message: error.response.data.message
                  });
                  this.showDismissibleAlert=true;
                  var errors = Object.values(error.response.data.errors);
                  this.submissionErros = errors;

              }
              else {
                this.showErrorMsg()
              }
              this.$refs.submitButton.disabled = false;
            })


        });
      }
    },

    onReset() {
      // Reset validation
      this.form = Object.assign({}, formShape);
      this.receipt = Object.assign({}, receiptShape);
      this.submissionErros = "";
      this.showDismissibleAlert = false;
      this.showPrintButton = false;
      this.submitted = false
      this.$nextTick(() => {
        this.$v.$reset()
      })
    },
  },
  beforeMount() {},
  created() {
    if (this.$store.state.samadh.countries.length == 0) {
      this.$store.dispatch('samadh/getCountries')
    }

    if (this.$store.state.samadh.idProofs.length == 0) {
      this.$store.dispatch('samadh/getIdProofs')
    }
    if (this.$store.state.samadh.tourTypes.length == 0) {
      this.$store.dispatch('samadh/getTourTypes')
    }
    if (this.$store.state.samadh.genders.length == 0) {
      this.$store.dispatch('samadh/getGenders')
    }

    if(this.aadharCardInfo !== null){
        this.form.idNumber = this.aadharCardInfo.uid;
        this.form.visitorname = this.aadharCardInfo.name;
        this.form.fatherHus = this.aadharCardInfo.gname;
        this.form.country = {"id": "IND", "name":"India"};
        this.form.idProof = {"id": "2", "name":"ADHAAR CARD"}
        this.form.birthYear = this.aadharCardInfo.yob;
        this.form.district = this.aadharCardInfo.dist;
        this.form.location = this.aadharCardInfo.loc;
        this.form.state = this.aadharCardInfo.state;
        this.form.postcode = this.aadharCardInfo.pc;
        this.form.location = this.aadharCardInfo.loc;
        var gender;
        if (this.aadharCardInfo.gender == 'M') {
              gender = {"id":"1", "name":"Male"};
          } else if (this.aadharCardInfo.gender == 'F') {
              gender = {"id":"2", "name":"Female"};
          } else {
              gender = {"id":"3", "name":"Other"};
          }
        this.form.gender = gender;

    }
    else{
    this.form.country = {"id": "IND", "name":"India"};
    this.form.tourType = {"id": "3", "name":"FAMILY"}
  }

  }
}
</script>

<style media="screen">
  .danger,
  .danger .dropdown-toggle,
  .danger .selected-tag {
    color: #f86c6b;
    border-color: #f86c6b;
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23f86c6b' viewBox='-2 -2 7 7'%3e%3cpath stroke='%23f86c6b' d='M0 0l3 3m0-3L0 3'/%3e%3ccircle r='.5'/%3e%3ccircle cx='3' r='.5'/%3e%3ccircle cy='3' r='.5'/%3e%3ccircle cx='3' cy='3' r='.5'/%3e%3c/svg%3E");
    background-repeat: no-repeat;
    background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
    background-position: right calc(0.375em + 0.95rem) center;
  }
  .danger-span{
    width:100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #f86c6b;

  }

  .borderCard{
    border: 1px solid #e3e8ec;
  }
</style>
